/**
 * Contacts & Favorites API Service
 */

import apiClient from '../client';
import type {
  Contact,
  ContactsResponse,
  FavoriteContact,
  FavoritesResponse,
  AddFavoriteResponse,
  RemoveFavoriteResponse,
} from '../types/contacts.types';

const BASE_URL = '/tenants/users';

export const contactsService = {
  /**
   * Get all contacts (users in tenant, excluding current user)
   */
  getAllContacts: async (currentUserId: string): Promise<Contact[]> => {
    // UDC expects array of filter objects, not dictionary
    const filters = JSON.stringify([
      {
        id: 'f1',
        column: 'id',
        operator: 'ne',
        value: currentUserId,
      },
      {
        id: 'f2',
        column: 'is_active',
        operator: 'eq',
        value: true,
      },
    ]);

    const response = await apiClient.get<ContactsResponse>(
      `${BASE_URL}?profile=basic&per_page=100&filters=${encodeURIComponent(filters)}`
    );
    // UDC returns data in response.data.data, not response.data.items
    return response.data.data || [];
  },

  /**
   * Get favorite contacts
   */
  getFavorites: async (): Promise<FavoriteContact[]> => {
    const response = await apiClient.get<FavoritesResponse>(
      `${BASE_URL}/favorites?per_page=100`
    );
    return response.data.items;
  },

  /**
   * Add user to favorites
   */
  addToFavorites: async (userId: string): Promise<AddFavoriteResponse> => {
    const response = await apiClient.post<AddFavoriteResponse>(
      `${BASE_URL}/id/${userId}/favorite`
    );
    return response.data;
  },

  /**
   * Remove user from favorites
   */
  removeFromFavorites: async (
    userId: string
  ): Promise<RemoveFavoriteResponse> => {
    const response = await apiClient.delete<RemoveFavoriteResponse>(
      `${BASE_URL}/id/${userId}/favorite`
    );
    return response.data;
  },
};
